module.exports = __webpack_public_path__ + "static/media/bl1.d4028b17.jpg";